<template>
    <svg viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 5.04688L1.74845e-07 4.04688L4.04688 2.36207e-06L8.09375 4.04688L7.09375 5.04688L4.04688 2L1 5.04688Z" fill="#9d9d9d"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGDropdownSwitchArrowUp"
    }
</script>

<style scoped>

</style>
